export default {
	quote_type: "sale_purchase",
	purchase: {
		internal_reference: "",
		address: {
			address_identifier: "",
			address_street: "",
			address_locality: "",
			address_city: "",
			address_province: "",
			address_postcode: "",
			address_country: "",
			address_country_code: "",
		},
		property_price: "",
		number_of_people: 1,
		mortgage: true,
		lender: "",
		first_time_buyer: false,
		second_property: false,
		new_build: false,
		leasehold: false,
		has_scheme: false,
		scheme: "",
	},
	remortgage: {
		internal_reference: "",
		address: {
			address_identifier: "",
			address_street: "",
			address_locality: "",
			address_city: "",
			address_province: "",
			address_postcode: "",
			address_country: "",
			address_country_code: "",
		},
		property_price: "",
		number_of_people: 1,
		lender: "",
		leasehold: false,
		shared_ownership: false,
		transfer_of_equity: false,
	},
	sale: {
		internal_reference: "",
		address: {
			address_identifier: "",
			address_street: "",
			address_locality: "",
			address_city: "",
			address_province: "",
			address_postcode: "",
			address_country: "",
			address_country_code: "",
		},
		property_price: "",
		number_of_people: 1,
		mortgage: true,
		lender: "",
		leasehold: false,
		has_scheme: false,
		scheme: "",
	},
};
